import { ResourceHelperService } from "../resource-helper.service";

/**
* A service that allows searching of products
*/
export class ProductSearchService {
  public resource: InterACT.Interfaces.IResource<InterACT.Interfaces.ProductSearch.SearchResultsResponse>;

  constructor(
    private $resource: ng.resource.IResourceService,
    private resourceHelperService: ResourceHelperService
  ) {
    this.resource = $resource('api/product-search/:tags');
  }

  /**
   * Searches for all products matching a query
   *
   * @param page The currentPage on the view
   * @param perPageCount The number of rows in the table on the view
   * @param queryString A query string used for matching records during data retrieval (optional)
   *
   * @returns a promise that resolves with a Product search response
   */
  public getProducts(page: number, perPageCount: number, queryString: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, queryString);
    return this.resource.get(options).$promise;
  }

  public getList(page: number, perPageCount: number, queryString: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, queryString);
    return this.resource.get(options).$promise;
  }
}